import { CALCULATORS } from './constants/calculators_c';
import _u from './util';
import _v from './vars';
import _t from './templates/templates_t';
import _ from 'lodash';

function getCalcWidg() {
    if (typeof userHpId != 'undefined' && userHpId != '' && !isNaN(Number(userHpId))) {
        let value = _.filter(CALCULATORS, {
            userHpId: userHpId.toString(),
        });
        if (value.length > 0) {
            document.getElementById('calculators-widget').classList.add("active");
            let ulTopics = document.getElementById('calculators-header');
            ulTopics.innerText = value[0].name;

            let urls = document.getElementById('pers-calculators-urls');
            value[0].urls.forEach(element => {
                urls.appendChild(_u.strToDom(_t.calculator(element)));
            });

            var li = document.getElementsByClassName("pers-calculators-name");

            for (var i = 0; i < li.length; i++) {
                li[i].addEventListener("click", (e) => {
                    let target = _u.getEventTarget(e);
                    let li = target.closest('li');
                    let newnode = [];
                    li.closest('ul').children.forEach(element => {
                        newnode.push(element);
                    });
                    let index = newnode.indexOf(li);

                    wmdPageLink('fy-rr_clc' + (index + 1).toString(), this);
                });
            }

            let button = document.getElementById('view-all-calculators');
            button.appendChild(_u.strToDom(_t.calculatorButton(value[0])));

            document.getElementById("view-all-calculators").addEventListener("click", function () { wmdPageLink('fy-rr_clcva', this) });
        }
    }
}

export default getCalcWidg;